import { SwiperItem } from '../../../libs/gin-tonic/components/swiper';
import { Component } from '../../../libs/gin-tonic/helpers/compiler';
import { ClockComponent } from '../clock/clock';

@Component({ className: 'js-history' })
export class HistoryComponent {
	static SLIDES_PER_VIEW = 3;

	constructor(private element: HTMLElement) {
		const vw = window.innerWidth;
		const wrapperWidth = vw / 100 * 91.66666;
		const clock = new ClockComponent(this.element.querySelector('.js-history-bg'));

		new SwiperItem(this.element, {
			scale: false,
			spacing: 40,
			vertical: false,
			mousewheel: false,
			breakpoints: {
				0: {
					slidesPerView: 1,
					width: (vw - 40),
					spaceBetween: 20,
				},
				576: {
					slidesPerView: 2,
					width: wrapperWidth
				},
				1200: {
					slidesPerView: 3,
					width: wrapperWidth
				},
			},
			events: {
				transitionStart(swiper) {
					const val = swiper.slides[swiper.activeIndex].getAttribute('data-history-bg');
					clock.updateTimerDisplay(val);
				},
				init(swiper) {
					const val = swiper.slides[swiper.activeIndex].getAttribute('data-history-bg');
					clock.updateTimerDisplay(val);
				},
			},
			initialSlide: 0,
			pagination: {
				el: this.element.querySelector<HTMLElement>('.swiper-pagination'),
				clickable: true,
				bulletClass: 'c-history__swiper__bullet',
				bulletActiveClass: 'is-active',
				renderBullet: function (index, className) {
					const label = this.slides[index]?.getAttribute('data-history-label');
					return '<span class="' + className + '">' + (label ? '<span class="c-text c-history__swiper__bullet__label">' + label + '</span>' : '') + '</span>';
				},
			},
			navigation: {
				nextEl: '.swiper-next',
				prevEl: '.swiper-prev'
			}
		});
	}
}
